<template>
    <BasePanel
        headline="lang_GENERAL_PANEL_CAPTION_SPLITS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                :items-per-page="300"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            >
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>

                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.license`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-license'">
                        {{ getLicence(item.license) }}
                    </div>
                </template>
                <template v-slot:[`item.salesType`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-sales-type'">
                        {{ getSalesType(item.salesType) }}
                    </div>
                </template>
                <template v-slot:[`item.salesUnit`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-sales-unit'">
                        {{ getSalesUnit(item.salesUnit) }}
                    </div>
                </template>
                
                <template v-slot:[`item.base`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-base'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.base, 'number') }}
                    </div>
                </template>  
                <template v-slot:[`item.share`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-split'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.share, 'number') }}
                    </div>
                </template>
                <template v-slot:[`item.region`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-region'">
                        {{ $alvPlugin.createRegionsToString(item.region) }}
                    </div>
                </template> 
                <template v-slot:[`item.category`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-category'">
                        {{ $t(getCategory(item.category)) }}
                    </div>
                </template>

                <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-' + item.id + '-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-inline-edit'"
                        icon="edit" 
                        :tooltipText="getEditIconText(item)"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import 
    { 
        DropdownContractsLabelPriceCategories, 
        DropdownContractsLabelSalesType,
        DropdownContractsLabelLicense,
        DropdownContractsLabelSalesUnits
    } 
from '@/assets/dropdowns/alvDropdowns.js'

import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "LabelContractsSplitsEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'contracts-label-edit-form-panel-splits'
        }
    },
    computed: {
        items() {
            // this.$store.commit('setIsLoading', true)
            // this.$store.dispatch('fetchLabelContractSplits')
            return this.$store.getters.getLabelContractsSplits
        },
        headers() {
            return [
                {
                    text: this.$t("lang_GENERAL_CAPTION_LICENSE"),
                    value: "license",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-license'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_SALES_TYPE"),
                    value: "salesType",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-sales-type'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_SALES_UNIT"),
                    value: "salesUnit",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-sales-unit'
                },
                {
                    text: this.$t("lang_CONTRACTS_LABEL_EDIT_SPLITS_PANEL_CAPTION_BASE") + ' %',
                    value: "base",
                    align: "right",
                    width: "105px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-base'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_SPLIT") + ' %',
                    value: "share",  
                    align: "right",
                    width: "105px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-shares'
                },
                {
                    text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_REGION"),
                    value: "region",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-region'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_CATEGORY"),
                    value: "category",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-category'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        addNewRow(){
            let alvId= this.$store.getters.getLabelContractsDetailsAlvId
            
            if(alvId === 'ALV000000000CL') {
                let contractName = this.$store.getters.getLabelContractsDetailsContractName
                let licensor = this.$store.getters.getLabelContractsDetailsLicensor
                let contractDate = this.$store.getters.getLabelContractsDetailsContractDate

                let isMainFormValidated = contractName !== null && licensor !== null && contractDate !== null

                if(isMainFormValidated){
                    this.$store.dispatch('saveLabelContractsForm')
                    this.setNewRow()
                } else {
                    this.$store.commit('setSnackbar', { 
                        type: 'error', 
                        msg: "Bitte erst die Pflichtfelder des Hauptformulars ausfüllen!"
                    })
                }
            } else {
                this.setNewRow()
            }
        },

        setNewRow() {
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultLabelContractsSplits)) 
            this.$store.commit('setLabelContractsSplitsEditingDialogDetails', defaultValues)
            this.$store.commit('setShowEditingDialog', true)
        },
        
        getLicence(licenseValue) {
           let licenseMatch = DropdownContractsLabelLicense.find(license => {
               return license.value === licenseValue
           })

           if(licenseMatch !== undefined)
                return this.$alvPlugin.isLangConst(licenseMatch.text) ? this.$t(licenseMatch.text) : licenseMatch.text
           else return ''
        },

        getSalesType(salesTypeValue) {
           let salesTypeMatch  = DropdownContractsLabelSalesType.find(type => {
               return type.value === salesTypeValue
           })

           if(salesTypeMatch !== undefined) {
               return this.$alvPlugin.isLangConst(salesTypeMatch.text) ? this.$t(salesTypeMatch.text) : salesTypeMatch.text
            } else return ''
        },

        getSalesUnit(salesUnitValue) {
           let salesUnitMatch = DropdownContractsLabelSalesUnits.find(unit => {
               return unit.value === salesUnitValue
           })

           if(salesUnitMatch !== undefined) return salesUnitMatch.text
           else return ''
        },

        getCategory(categoryValue) {
            let match = DropdownContractsLabelPriceCategories.find(category => {
                return category.value === categoryValue
            })

            if(match !== undefined) return match.text
            else return ''
        },

        deleteRow(item) {
            // set the selected share/row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit("setSelectedLabelContractsSplits", [item.id])
            this.$store.commit('setDeletionDialogContext', 'SelectedLabelContractsSplits')
            this.$store.commit('setShowDeletionDialog', true)
        },

        editInlineFunction(item) {
            this.$store.commit('setSelectedLabelContractsSplits', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            // formatting numbers to show in correct notation
            detailsDeepCopy['base'] = this.$alvPlugin.getNumberLocalization(detailsDeepCopy['base'], 'number')
            detailsDeepCopy['share'] = this.$alvPlugin.getNumberLocalization(detailsDeepCopy['share'], 'number')

            // set the copy in dialog details to edit
            this.$store.commit('setLabelContractsSplitsEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowEditingDialog', true) 
        },
        getEditIconText(item) {
            let text = this.$t('lang_GENERAL_CAPTION_ICON_EDIT') 
            if(item.licensor !== null)
                text += ': ' + item.licensor.name + ' (' + item.licensor.alvId + ')'
            return text
        }
    }
}
</script>